import * as _ from 'lodash';
import FactureEntete from './facture.entete.model';
let unregisterReinit;

export default class FactureEnteteController {
	static $inject = [
		'$scope',
		'$stateParams',
		'$sce',
		'$filter',
		'notification',
		'FacturesCommunicationService',
		'FacturesService',
		'moment',
		'globalizationManagementService',
		'CentreGestionService',
		'MassiaRightsService',
		'SocietesService',
		'MassiaSelectService'
	];

	constructor(
		$scope,
		$stateParams,
		$sce,
		$filter,
		notification,
		FacturesCommunicationService,
		FacturesService,
		moment,
		globalizationManagementService,
		CentreGestionService,
		MassiaRightsService,
		SocietesService,
		MassiaSelectService
	) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.$sce = $sce;
		this.$filter = $filter;
		this.FacturesCommunicationService = FacturesCommunicationService;
		this.FacturesService = FacturesService;
		this.notification = notification;
		this.loading = false;
		this.codeLoading = false;
		this.moment = moment;
		this.CentreGestionService = CentreGestionService;
		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.MassiaRightsService = MassiaRightsService;
		this.SocietesService = SocietesService;
		this.MassiaSelectService = MassiaSelectService;
		this._ = _;
		this.listeSocietes = [];
		this.outputSocietes = [];
		this.societeComLocked = false;
		this.listeSitesCom = [];
		this.outputSitesCom = [];
		this.siteComLocked = false;
		this.regimeFiscalOptions = [
			{ id: 1, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_INTRACOMMUNAUTAIRE' },
			{ id: 2, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_AUTOLIQUIDATION' },
			{ id: 3, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_EXPORT' },
			{ id: 4, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_EXONERATION' },
			{ id: 5, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_FRANCHISE' },
			{ id: 6, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_HORSCHAMP' }
		];
	}

	async $onInit() {
		this.id = this.$stateParams.id;
		this.isEditMode = false;
		await this.checkEdition();

		unregisterReinit = this.FacturesCommunicationService.registerReinit(() => this.initForm());
		this.initEntete();
		await this.getCoordonneesBancairesSociete();
		if (!this.isEditMode) {
			this.preselectCoordonneeDefaut();
		}
		await this.initiateClient();

		const _this = this;
		this.$scope.$watch('$ctrl.entete.dateGeneration', function () {
			_this.processCalc();
			_this.getRemarqueFromSociete();
		});
		// Régime fiscal / motif d'exonération : uniquement pertinents s'il existe une ligne à TVA 0 %.
		// Dès qu'il n'y en a plus, on purge les deux champs pour ne pas persister de valeur obsolète.
		this.$scope.$watch(
			() => _this.hasZeroVATLines(),
			(hasZero) => {
				if (!hasZero && _this.entete) {
					_this.entete.regimeFiscalFactureX = null;
					_this.entete.motifExonerationFactureX = null;
				}
			}
		);
		await this.getCoordonneesBancairesSociete();
	}

	$onDestroy() {
		unregisterReinit();
	}

	async checkEdition() {
		if (this.$stateParams && this.$stateParams.id) {
			this.isEditMode = true;
		} else {
			this.isEditMode = false;
		}
	}

	async initEntete() {
		this.startLoading();

		this.unites = [];
		this.modesCalcul = [];
		this.facture = this.facture || {};
		this.etatBloque = false;
		this.entete = new FactureEntete(this.facture.entete);
		this.factureEntete = this.entete;
		this.siteUtilisateur = this.siteUtilisateur || { id: null, libelle: null };
		this.siteClient = this.siteClient || { id: null, libelle: null };
		this.clientDivers = this.clientDivers || { id: null, libelle: null };
		this.listePiecesFacturation = null;
		this.facture.entete = this.entete;
		this.idSiteCommentaire = 0;
		try {
			// this.getEtats();
			await this.getPresentationFacture();
			this.getListeModesPaiement();
			this.getListeSocietes();
			if (this.isEditMode) {
				this.getTypes();
				this.setFactureAsTypeAhead();
				this.loadSitesCom(this.entete.idSociete);
				if (this.entete.dateEcheance) {
					this.savedDateEcheance = angular.copy(this.entete.dateEcheance);
				} else {
					this.savedDateEcheance = this.moment().format(this.dateFormat);
				}
				this.idSiteCommentaire = this.entete.idClient;
			} else {
				// initialise les dates de debut et fin à la première seconde et la dernière du jour
				const maDate = new Date();
				this.entete.dateGeneration = this.moment(maDate).format(this.dateFormat);
				this.entete.isSiteModifiable = true;
				this.getTypesCreate();
				if (this.listePresentationFacture.length == 1) {
					this.entete.idPresentation = this.listePresentationFacture[0].id;
				}
			}
		} catch (err) {
			if (err.status === 404) {
				this.goListFacture();
			}
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		} finally {
			this.stopLoading();
		}
		if (!this.entete.idEtatFacture) {
			this.entete.idEtatFacture = 0;
			this.etatBloque = true;
		}
	}

	async getCommentaireClient(id) {
		if (id && id != this.idSiteCommentaire) {
			try {
				this.entete.commentaire = await this.FacturesService.getCommentaireClient(id);
				this.idSiteCommentaire = id;
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
			}
		}
	}

	reinitRemarque() {
		this.entete.remarque = this.remarqueSociete;
	}

	async getRemarqueFromSociete() {
		try {
			this.remarqueSociete = null;
			if (this.entete.idSociete && this.entete.dateGeneration) {
				const dateFacture = this.formatDateForBackend(this.entete.dateGeneration);
				this.remarqueSociete = await this.FacturesService.getCommentaireTempSociete(this.entete.idSociete, dateFacture);
				if (this.remarqueSociete) {
					const label = this.$filter('translate')('FACTURES.REMARQUE_SOCIETE_TOOLTIP');
					this.tooltipRemarqueSociete = this.$sce.trustAsHtml(`${label}<br>${this.remarqueSociete}`);
				} else {
					this.tooltipRemarqueSociete = null;
				}
				if (this.remarqueSociete && !this.entete.remarque) {
					this.entete.remarque = this.remarqueSociete;
				}
			}
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		}
	}

	async getTypes() {
		if (!this.listeTypes) {
			this.startLoading();
			try {
				this.listeTypes = await this.FacturesService.getTypes();
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
			} finally {
				this.stopLoading();
			}
		}
	}
	async getTypesCreate() {
		if (!this.listeTypes) {
			this.startLoading();
			try {
				const hasUpdateFactureRight = await this.MassiaRightsService.userHasRight('facturemanuel', 'create', 'gestion');
				const hasUpdateAvoirManuelRight = await this.MassiaRightsService.userHasRight('avoirmanuel', 'create', 'gestion');
				let droit = 'empty';
				if (hasUpdateAvoirManuelRight && hasUpdateFactureRight) {
					droit = 'all';
				} else {
					if (hasUpdateAvoirManuelRight) {
						droit = 'avoir';
					}
					if (hasUpdateFactureRight) {
						droit = 'facture';
					}
				}
				if (droit != 'empty') {
					this.listeTypes = await this.FacturesService.getTypesSurCreation(droit);
				}
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
			} finally {
				this.stopLoading();
			}
		}
	}
	async getPresentationFacture() {
		if (!this.listePresentationFacture) {
			this.startLoading();
			try {
				const tmp = await this.FacturesService.getPresentation();
				this.listePresentationFacture = tmp.items;
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
			} finally {
				this.stopLoading();
			}
		}
	}
	async getListeModesPaiement() {
		if (!this.listeModesPaiement) {
			this.startLoading();
			try {
				this.listeModesPaiement = await this.FacturesService.getModesPaiement();
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
			} finally {
				this.stopLoading();
			}
		}
	}

	async getListeSocietes() {
		try {
			const societes = await this.FacturesService.getSocietes();
			const currentId = this.entete && this.entete.idSociete;
			this.listeSocietes = (societes || []).map((s) => ({
				id: s.id,
				libelle: s.libelle,
				selected: s.id === currentId
			}));
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		}
	}

	async onSocieteClick(data) {
		if (this.listeSocietes) {
			this.listeSocietes.forEach((s) => (s.selected = data && s.id === data.id));
		}
		this.entete.idSociete = (data && data.id) || null;
		await this.getPiecesFacturationLiees(true);
	}

	async loadSitesCom(idSociete) {
		if (!idSociete) {
			this.listeSitesCom = [];
			return;
		}
		try {
			const currentId = this.entete && this.entete.idSiteCommercial;
			const sites = await this.FacturesService.getSitesCom(idSociete);
			console.log('🔥 - FactureEnteteController - loadSitesCom - currentId:', currentId);
			this.listeSitesCom = (sites || []).map((s) => ({
				id: s.id,
				libelle: s.libelle,
				selected: s.id == currentId
			}));
		} catch (err) {
			if (err.data) this.notification.error(err.data);
			else throw err;
		}
	}

	onSiteComClick(data) {
		if (this.listeSitesCom) {
			this.listeSitesCom.forEach((s) => (s.selected = data && s.id === data.id));
		}
		this.entete.idSiteCommercial = (data && data.id) || null;
		this.entete.nomSiteCommercial = (data && data.libelle) || null;
	}

	async setTypeAheadAs(val) {
		if (!this.facture) {
			this.facture = {};
		}
		switch (val) {
			case 'siteClient':
				if (!this.siteClient?.id) {
					if (this.entete.idClient) {
						this.entete.idClient = null;
						this.entete.nomClient = null;
						this.preselectCoordonneeDefaut();
					}
					break;
				}
				this.entete.idClient = this.siteClient.id;
				this.entete.nomClient = this.siteClient.libelle;
				this.facture.entete.isClientGenerique = this.siteClient.isGenerique;
				this.entete.idClientDivers = null;
				this.entete.nomClientDivers = null;
				this.clientDivers.id = null;
				this.clientDivers.libelle = null;
				await this.getCommentaireClient(this.siteClient.id);
				if (this.entete.idSociete != null) {
					await this.getPiecesFacturationLiees();
				}
				// si il exite récupère le mode de paiement paramétrer pour le client
				await this.getModePaiement();
				await this.getCoordBancairesParamClient();
				break;
			case 'clientDivers':
				this.entete.idClientDivers = this.clientDivers.id;
				this.entete.nomClientDivers = this.clientDivers.libelle;
				break;
			case 'chantier':
				this.entete.idChantier = this.entete.nomChantier.id;
				this.entete.nomChantier = this.entete.nomChantier.libelle;
				break;
		}
	}
	setFactureAsTypeAhead() {
		// this.siteUtilisateur = {
		//     id: this.entete.idSiteCommercial,
		//     libelle: this.entete.nomSiteCommercial
		// };
		this.siteClient = {
			id: this.entete.idClient,
			libelle: this.entete.nomClient
		};
		this.clientDivers = {
			id: this.entete.idClientDivers,
			libelle: this.entete.nomClientDivers
		};
		this.chantier = {
			id: this.entete.idChantier,
			libelle: this.entete.nomChantier
		};
	}

	// Fontionnel
	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	async getNomSitesCommerciaux(valeur) {
		try {
			const res = await this.FacturesService.getNomSitesCommerciaux(valeur, this.entete.idSociete);
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getNomSitesClients(valeur) {
		try {
			const res = await this.FacturesService.getNomSitesClients(valeur, this.entete.idSociete);
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getNomClientDivers(valeur) {
		try {
			const res = await this.FacturesService.getNomClientDivers(valeur, this.entete.idSociete);
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getNomChantiersByClient(valeur) {
		try {
			const res = await this.FacturesService.getNomChantiersByClient(valeur, this.entete.idClient);
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	// Convertit date (format display DD/MM/YYYY ou Date) en Date object pour le backend
	formatDateForBackend(date) {
		if (!date) return new Date();
		if (angular.isDate(date)) return date;
		return this.moment.utc(date, this.dateFormat).toDate();
	}

	async processCalc() {
		if (this.entete.idModePaiement) {
			let dateGeneration = this.formatDateForBackend(this.entete.dateGeneration);

			const tempPaiementObject = {};
			tempPaiementObject.idModePaiement = this.entete.idModePaiement;
			tempPaiementObject.type = null;
			tempPaiementObject.echeance = null;
			tempPaiementObject.echeanceUnite = null;
			tempPaiementObject.modeCalcul = null;
			tempPaiementObject.jourFinDeMois = null;
			tempPaiementObject.dateEcheance = new Date();

			this.entete.dateEcheance = await this.FacturesService.GetDateSimulated(dateGeneration, tempPaiementObject);
		}
	}

	async getPiecesFacturationLiees(fromSociete = false) {
		if (fromSociete && !this.entete.idClient) {
			await this.getCoordonneesBancairesSociete();

			if (this.listeCoordonneesBancaires.length > 0) {
				const dafaultCoordonneesBancaires = this.listeCoordonneesBancaires.find((x) => x.isDefaut)?.id;
				this.entete.idCoordonneesBancaires = dafaultCoordonneesBancaires || this.listeCoordonneesBancaires[0]?.id;
			}
		}
		if (fromSociete) {
			await this.getRemarqueFromSociete();
			await this.loadSitesCom(this.entete.idSociete);
		}
		this.siteUtilisateur = {
			id: null,
			libelle: null
		};
		await this.initiateClient();
		if (this.entete?.idSociete != null && this.entete?.idClient != null && this.entete?.idTypeFacture != null) {
			this.listePiecesFacturation = await this.FacturesService.getPiecesFacturationLiees(
				this.entete.idSociete,
				this.entete.idClient,
				this.entete.idTypeFacture
			);
		}
	}

	//async getPiecesFacturationLiees(fromSociete = false) {
	//	if (fromSociete) {
	//		this.siteUtilisateur = {
	//			id: null,
	//			libelle: null
	//		};
	//	}
	//	await this.initiateClient();
	//	if (this.entete.idSociete !== null && this.entete.idClient !== null && this.entete.idTypeFacture !== null) {
	//		this.listePiecesFacturation = await this.FacturesService.getPiecesFacturationLiees(
	//			this.entete.idSociete,
	//			this.entete.idClient,
	//			this.entete.idTypeFacture
	//		);
	//	}
	//}
	async initiateClient() {
		this.inputFiltreClients = await this.refreshFiltreClients();
		//await this.preselectFiltreSites();
	}

	async saveSelectedClients() {
		this.facture.idFiltreClients = [];
		for (let i = 0; i < this.outputFiltreClients.length; i++) {
			const siteClient = this.outputFiltreClients[i];
			this.facture.idFiltreClients.push(siteClient.id);
		}
	}

	async refreshFiltreClients() {
		let data;
		try {
			data = await this.FacturesService.getFiltreClients(this.entete.idSociete);
		} catch (ex) {
			data = [];
		}
		return data;
	}

	async getModePaiement() {
		const filter = {
			clientId: this.siteClient.id,
			date: this.moment().format(this.dateFormat)
		};
		const groupesParametres = await this.CentreGestionService.getParametersWithFilter('SiteClient', this.siteClient.id, filter);
		let modePaiement = -1;
		if (groupesParametres) {
			const factu = groupesParametres.find((gp) => gp.codeGroupe === 'FACTU');
			modePaiement = this.getParameterData(factu, 'modePaiement');

			if (modePaiement) {
				this.entete.idModePaiement = Number(modePaiement);
				this.processCalc();
			}
		}
	}

	//Récupère les coordonnées bancaires du client ou du type de client
	async getCoordBancairesParamClient() {
		this.loadingCoordBancaires = true;
		try {
			// Parallélisation : les deux appels sont indépendants
			const [groupesParametresClient, clients] = await Promise.all([
				this.CentreGestionService.getParametersWithFilter('SiteClient', this.siteClient.id, this.getCoordBancairesFilter('client')),
				this.MassiaSelectService.getClients(this.entete.idSociete)
			]);
			console.log('🔥 - FactureEnteteController - getCoordBancairesParamClient - groupesParametresClient:', groupesParametresClient);
			if (!groupesParametresClient) return;

			const factuClient = groupesParametresClient.find((gp) => gp.codeGroupe === 'FACTU');
			let coordonneeBancaire = this.getParameterData(factuClient, 'CoordBancai');

			if (!coordonneeBancaire) {
				console.log('🔥 - FactureEnteteController - getCoordBancairesParamClient - coordonneeBancaire:', coordonneeBancaire);
				const client = clients.find((x) => x.id === this.siteClient.id);
				const groupesParametresTypeClient = await this.CentreGestionService.getParametersWithFilter(
					'TypeClient',
					client.idTypeclient,
					this.getCoordBancairesFilter('typeClient', client)
				);
				const factuTypeClient = groupesParametresTypeClient?.find((gp) => gp.codeGroupe === 'FACTU');
				console.log('🔥 - FactureEnteteController - getCoordBancairesParamClient - factuTypeClient:', factuTypeClient);
				console.log(
					'🔥 - FactureEnteteController - getCoordBancairesParamClient - groupesParametresTypeClient:',
					groupesParametresTypeClient
				);
				coordonneeBancaire = this.getParameterData(factuTypeClient, 'CoordBancai');
				console.log('🔥 - FactureEnteteController - getCoordBancairesParamClient - coordonneeBancaire:', coordonneeBancaire);
			}

			if (coordonneeBancaire) {
				this.entete.idCoordonneesBancaires = Number(coordonneeBancaire);
			}
		} finally {
			this.loadingCoordBancaires = false;
		}
	}

	getCoordBancairesFilter(filterType, client = null) {
		const filter = {
			client: {
				clientId: this.siteClient.id,
				date: this.moment().format(this.dateFormat),
				societeId: this.entete.idSociete
			},
			typeClient: {
				typeClientId: client?.idTypeclient,
				date: this.moment().format(this.dateFormat),
				societeId: this.entete.idSociete
			}
		};
		console.log('🔥 - FactureEnteteController - getCoordBancairesFilter - filter:', filter);

		return filter[filterType];
	}

	getParameterData(factu, parametre) {
		const modesPaiements = factu?.parametres.find((p) => p.codeParametre === parametre);
		const donnees = modesPaiements?.donnees.map((x) => x.valeurs.map((v) => v.valeur));
		const values = this._.flattenDeep(donnees);
		if (values && values.length > 0) {
			return values.find((x) => Number(x) > 0);
		}
	}

	// Récupère les coordonnées bancaires de la société
	async getCoordonneesBancairesSociete() {
		try {
			if (this.entete?.idSociete) {
				const coordBancaires = await this.SocietesService.getCoordonnees(this.entete.idSociete);
				this.listeCoordonneesBancaires = coordBancaires.map((item) => {
					return {
						id: item.id,
						libelle: `${item.nomBanque} - ${item.compte}`,
						isDefaut: item.isDefaut
					};
				});
			}
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		}
	}

	async changeCoordonneesBancaires(data) {
		if (!data) {
			this.entete.idCoordonneesBancaires = null;
		}
	}

	async onSocieteChange() {
		await this.getCoordonneesBancairesSociete();
		if (!this.entete.idClient) {
			this.preselectCoordonneeDefaut();
		}
	}

	preselectCoordonneeDefaut() {
		if (!this.listeCoordonneesBancaires || this.listeCoordonneesBancaires.length === 0) {
			this.entete.idCoordonneesBancaires = null;
			return;
		}
		const defaut = this.listeCoordonneesBancaires.find((c) => c.isDefaut);
		this.entete.idCoordonneesBancaires = defaut ? defaut.id : this.listeCoordonneesBancaires[0].id;
	}

	hasZeroVATLines() {
		return ((this.entete && this.entete.factureArticles) || []).some((a) => a.tauxTVA === 0);
	}
}
